import React, { Fragment } from "react";

type CheckboxProps = {
  label: string;
  name?: string;
  value: string | boolean;
  id?: string;
  defaultChecked?: boolean;
  checked?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  ariaDescribedBy?: string;
};

const Checkbox = ({
  id,
  label,
  name = "",
  value,
  defaultChecked,
  checked,
  onChange,
  onBlur,
  ariaDescribedBy,
}: CheckboxProps) => {
  return (
    <label className="inline-flex items-center">
      <div className="bg-white border border-gray-600 w-6 h-6 flex flex-shrink-0 justify-center items-center mr-1 focus-within:outline focus-within:outline-offset-2 focus-within:outline-2 focus-within:outline-black/80">
        <input
          type="checkbox"
          className={`opacity-0 absolute svg-checkmark`}
          defaultChecked={defaultChecked}
          value={value.toString()}
          checked={checked}
          onChange={onChange}
          onBlur={onBlur}
          id={id}
          name={name}
          aria-describedby={ariaDescribedBy}
        />
        <svg
          className="fill-current hidden w-4 h-4 text-steel-blue-600 pointer-events-none"
          viewBox="0 0 20 20"
        >
          <path d="M0 11l2-2 5 5L18 3l2 2L7 18z" />
        </svg>
      </div>
      <span className="ml-2">{label}</span>
    </label>
  );
};

export default Checkbox;
